import { createAction, props } from '@ngrx/store';

import { AccountCustomer, Country, DocType3A, Employment3ADetail, PersonalDetails } from '@shared/models/Account';
import { DocType } from '@shared/models/Profile';

export const fetchPersonalDetails = createAction('[AO 3A] Fetch personal details');
export const fetchPersonalDetailsSuccess = createAction(
  '[AO 3A] Fetch personal details success',
  props<{ personalDetails: PersonalDetails }>()
);

export const fetchCountryList = createAction('[AO 3A] Fetch country list');
export const fetchCountryListSuccess = createAction('[AO 3A] Fetch country list success', props<{ countries: Country[] }>());

export const updatePersonalDetails = createAction(
  '[AO 3A] Update personal details',
  props<{ personalDetails: PersonalDetails; step: number; isSummary: boolean }>()
);
export const updatePersonalDetailsSuccess = createAction(
  '[AO 3A] Update personal details success',
  props<{ personalDetails: PersonalDetails }>()
);

export const updateAccountOpeningStep = createAction('[AO 3A] Update 3a account opening', props<{ step: number }>());
export const updateAccountOpeningStepSuccess = createAction('[AO 3A] Update 3a account opening success', props<{ step: number }>());

export const updateSummaryStep = createAction('[AO 3A] Update 3a account summary step', props<{ step: number }>());

export const fetchAccountOpeningCustomer = createAction('[AO 3A] Fetch 3a account opening');
export const fetchAccountOpeningCustomerSuccess = createAction(
  '[AO 3A] Fetch 3a account opening success',
  props<{ customer: AccountCustomer }>()
);

export const fetchEmploymentDetail = createAction('[AO 3A] Fetch 3a account opening employment detail');
export const fetchEmploymentDetailSuccess = createAction(
  '[AO 3A] Fetch 3a account opening employment detail success',
  props<{ employmentDetail: Employment3ADetail }>()
);
export const updateEmploymentDetail = createAction(
  '[AO 3A] Update 3a account opening employment detail',
  props<{ employmentDetail: Partial<Employment3ADetail>; step: number }>()
);
export const updateEmploymentDetailSuccess = createAction(
  '[AO 3A] Update 3a account opening employment detail success',
  props<{ employmentDetail: Employment3ADetail }>()
);

export const fetchDocuments = createAction('[AO 3A] Fetch 3a verification documents');
export const fetchDocumentsSuccess = createAction('[AO 3A] Fetch 3a verification documents success', props<{ documents: DocType[] }>());

export const updateDocuments = createAction('[AO 3A] Update 3a verification documents', props<{ documents: DocType3A }>());
export const updateDocumentsSuccess = createAction('[AO 3A] Update 3a verification documents success', props<{ documents: DocType[] }>());
export const submitNextStep = createAction('[AO 3A] Proceed to next onboarding step', props<{ step: number; path: string }>());

export const enter3AAgreement = createAction('[AO 3A] Enter 3a agreement');
export const enter3AAgreementSuccess = createAction('[AO 3A] Enter 3a agreement success');

export const update3AAccountDataFilled = createAction('[AO 3A] Update 3a user account data filled');
